import { defineComponent, h, onUnmounted } from 'vue';
import { SettingsEntrySingleLine } from '@features/user-settings';
import { img } from '@phi/components';
import { CurvatureCombIcon } from '../curvature-comb-icon';
import FormButtonSelect from '@frontend/components/FormButtonSelect';
import {
    toggle_edge_curvatures,
    set_number_of_curvature_combs,
    showing_curvature_combs,
    number_of_curvature_combs,
} from '@features/curvature-combs';

type Comb = 20 | 50 | 100 | 200;
const CombButtonSelect = FormButtonSelect<Comb>();
const CombOptions = ([ 20, 50, 100, 200 ] as Comb[]).map(x => ({ value: x, label: x.toString() }));

export const CurvatureCombCount = defineComponent({
    setup() {
        const was_showing_curvatures = showing_curvature_combs.value;

        function on_update(x: Comb) {
            set_number_of_curvature_combs(x);
        }

        onUnmounted(() => {
            if (!was_showing_curvatures && showing_curvature_combs.value)
                toggle_edge_curvatures();
        });

        return () => SettingsEntrySingleLine(
            'Curvature combs per edge',

            undefined,

            img(CurvatureCombIcon, 'Curvature combs per edge'),

            h(CombButtonSelect, {
                options: CombOptions,
                value: number_of_curvature_combs.value,
                'onUpdate:value': on_update,
            })
        );
    }
});
